import PoiLayer from "./PoiLayer";
import map from "../../app/map";


/**
 * Clase que gestiona la visualización y manipulación de puntos de interés (POI) en un mapa.
 */
class PoiLabels{

    /**
     * Crea una instancia de PoiLabels.
     * @constructor
     */
    constructor() {
        this.initProperties();
        this.layer = new PoiLayer(this.ident)
    }

    /**
     * Inicializa las propiedades de la instancia.
     * @private
     */
    initProperties(){
        /** @type {string} */
        this.ident = "empty";
        /** @type {Object} */
        this.markers = {};
        /** @type {null|Object} */
        this.data = null;
        /** @type {number} */
        this.prevZoom = 0;
        /** @type {boolean} */
        this.isActive = false;
        /** @type {number} */
        this.syncCounter = 0;
        /** @type {number} */
        this.minZoom = 5;
        /** @type {string} */
        this.pluginIdent = "detail";
        /** @type {number[]} */
        this.popupOffset = [20, -15];
        /** @type {Object} */
        this.map = map;

    }

    /**
     * Activa la capa de puntos de interés.
     */
    activate() {
        this.isActive = true;
        this.map.addLayer(this.layer);
        this.download();
        this.map.on("zoomstart", this.delete, this);
        this.map.on("zoomend", this.render, this);
    }


    /**
     * Desactiva la capa de puntos de interés.
     */
    deactivate() {
        this.isActive = false;
        this.lastUrl = null;
        this.data = null;
        this.cancel();
        this.map.removeLayer(this.layer);
        this.map.off("zoomstart", this.delete, this);
        this.map.off("zoomend", this.render, this);
    }

    /**
     * Elimina un marcador de punto de interés.
     * @param {string} id - Identificador del marcador a eliminar.
     */
    deleteMarker(id) {
        this.layer.replaceMarker(id, "");
        delete this.markers[id];
    }

    /**
     * Retorna un objeto con atributos para mostrar un POI.
     * @param {*} t
     * @param {*} o
     * @returns {Object}
     */
    display (t, o) {
        return {
            attrs: []
        }
    }

    /**
     * Elimina todos los marcadores de puntos de interés.
     * @private
     */
    delete() {
        this.markers = {};
        this.lastUrl = null;
        this.layer.removePois();
    }

    cancel() {
        this.syncCounter++;
    }

    /**
     * Método para redibujar los puntos de interés.
     */
    redraw() {}
    /**
     * Método para renderizar los puntos de interés.
     */
    render() {}
    /**
     * Método para descargar datos de puntos de interés.
     */
    download() {}

}

export default PoiLabels;
